module.exports = __webpack_public_path__ + "img/background-desktop-mascot.64fb9f31.png";